import React from 'react';
import { WithTranslation } from 'next-i18next';

import { withTranslation } from 'lib/i18n';

import Entry from './Entry';
import EntriesWrap from './styled/EntriesWrap';
import Year from './styled/Year';

interface EntriesProps extends WithTranslation {
  year: string;
  last: boolean;
  months?: string[];
}

const Entries: React.FC<EntriesProps> = ({ year, months, last, t }) => (
  <EntriesWrap>
    <Year>{year}</Year>
    {months !== undefined ? (
      months.map((month, i) => (
        <Entry
          key={month}
          month={t(`common:months.${month}`)}
          text={t(`pages:company.history.year_${year}.${month}`)}
          first={i === 0}
          last={last && i === months.length - 1}
        />
      ))
    ) : (
      <Entry
        key={year}
        text={t(`pages:company.history.year_${year}`)}
        last={true}
        first={true}
      />
    )}
  </EntriesWrap>
);

export default withTranslation(['pages', 'common'])(Entries);
